import ajax from '@fdaciuk/ajax'
class AjaxSearch
{
  constructor()
  {
  }
  init()
  {
    const searchAdress = document.querySelector('.js-search-alians');
    if(searchAdress)
    {
      const searchAdressSubmit = document.querySelector('.alians-search__submit');
      const searchResults = document.querySelector('.js-search-results');
      searchAdressSubmit.addEventListener('click', searchByAdress);
      searchAdress.addEventListener('submit', (e) =>
      {
        e.preventDefault();
      })
      function searchByAdress()
      {
        let searchParameter = document.querySelector('.alians-search__input').value;
        let url = window.location.origin+'/wp-admin/admin-ajax.php/?action=alianssearchbyadress';
        let request = ajax
        (
          {
            method: 'POST',
            url: url,
            data:
              {
                parameter: searchParameter,
              }
          }
        )
        request.then(function(response)
        {
          searchResults.innerHTML = response;
        })
      }
    }
    const searchCity = document.querySelector('.js-search-city');
    if(searchCity)
    {
      searchCity.addEventListener('change', searchByCity);
      const searchResults = document.querySelector('.js-search-results');
      function searchByCity()
      {
        let searchParameter = searchCity.value;
        let url = window.location.origin+'/wp-admin/admin-ajax.php/?action=alianssearchbycity';
        let request = ajax
        (
          {
            method: 'POST',
            url: url,
            data:
              {
                parameter: searchParameter,
              }
          }
        )
        request.then(function(response)
        {
          searchResults.innerHTML = response;
        })
      }
    }
  }
}
export default new AjaxSearch();
